// extracted by mini-css-extract-plugin
export var disabled = "_l-5";
export var error = "_l-1";
export var fitContent = "_l-6";
export var hasSuffix = "_l-4";
export var iconWrapper = "_l-b";
export var infoIconWrapper = "_l-d _l-b";
export var input = "_l-a";
export var inputWrapper = "_l-0";
export var large = "_l-8";
export var leadingIconWrapper = "_l-c _l-b";
export var measureBox = "_l-e";
export var medium = "_l-7";
export var readonly = "_l-2";
export var small = "_l-3";
export var suffix = "_l-9";